import dayjs from "dayjs";
import { SUMMARY_PAGE_LAST_DAYS_LENGHT } from "./config";

export const sortByDateFunction = (fetchDateField: Function, desc = true) => {
  if (desc) {
    return (a: any, b: any) => (fetchDateField(a) < fetchDateField(b) ? 1 : -1);
  }
  return (a: any, b: any) => (fetchDateField(a) >= fetchDateField(b) ? 1 : -1);
};

export const getLatestBasedOnStartDatum = (list: any[]) => {
  const latest = [] as any[];
  const nowDate = dayjs();
  list.forEach((listItem) => {
    if (
      nowDate.diff(dayjs(listItem.startDatum), "day") <=
      SUMMARY_PAGE_LAST_DAYS_LENGHT
    ) {
      latest.push(listItem);
    }
  });
  return latest;
};

export const getLatestBasedOnStartDate = (list: any[]) => {
  const latest = [] as any[];
  const nowDate = dayjs();
  list.forEach((listItem) => {
    if (
      nowDate.diff(dayjs(listItem.startDate), "day") <=
      SUMMARY_PAGE_LAST_DAYS_LENGHT
    ) {
      latest.push(listItem);
    }
  });
  return latest;
};

export const getLatestBasedOnDate = (list: any[]) => {
  const latest = [] as any[];
  const nowDate = dayjs();
  list.forEach((listItem) => {
    if (
      nowDate.diff(dayjs(listItem.date), "day") <= SUMMARY_PAGE_LAST_DAYS_LENGHT
    ) {
      latest.push(listItem);
    }
  });
  return latest;
};

export const getSingleLatestBasedOnDate = (list: any[]) => {
  const latest = getLatestBasedOnDate(list);
  return latest.length > 0 ? latest[0] : undefined;
};

export const convertToVerbalDate = (d: string) => {
  const date = dayjs(d);
  const day = date.day();
  const month = date.month();
  switch (month) {
    case 0:
      return day + " januari";
    case 1:
      return day + " februari";
    case 2:
      return day + " mars";
    case 3:
      return day + " april";
    case 4:
      return day + " maj";
    case 5:
      return day + " juni";
    case 6:
      return day + " juli";
    case 7:
      return day + " augusti";
    case 8:
      return day + " september";
    case 9:
      return day + " oktober";
    case 10:
      return day + " november";
    case 11:
      return day + " december";
    default:
      return "";
  }
};
